import { useContext } from 'react';
import type { WorkflowContextType } from '@/types/workflow-types';
import { WorkflowContext } from '../context/WorkflowContext';


export const useWorkflow = (): WorkflowContextType => {
    const context = useContext(WorkflowContext);
    if (context === undefined) {
        throw new Error('useWorkflow must be used within a WorkflowProvider');
    }
    return context;
};